<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ComboBox from 'dashboard/components-next/combobox/ComboBox.vue';

const props = defineProps({
  widgets: { type: Array, default: () => [] },
  // Widget em edição: não pode ser operando de si mesmo.
  currentId: { type: Number, default: null },
});

const numeratorId = defineModel('numeratorId', {
  type: [Number, String],
  default: '',
});
const denominatorId = defineModel('denominatorId', {
  type: [Number, String],
  default: '',
});

const { t } = useI18n();

const operandOptions = computed(() =>
  props.widgets
    .filter(
      widget =>
        widget.visualization === 'number' &&
        ['count', 'sum'].includes(widget.config.measure.type) &&
        widget.id !== props.currentId
    )
    .map(widget => ({ value: widget.id, label: widget.title }))
);

const hasEnoughOperands = computed(() => operandOptions.value.length >= 2);
const isSameOperand = computed(
  () => !!numeratorId.value && numeratorId.value === denominatorId.value
);
</script>

<template>
  <div class="flex flex-col gap-4">
    <p v-if="!hasEnoughOperands" class="mb-0 text-sm text-n-ruby-9">
      {{ t('COMMERCIAL_WIDGETS_DIALOG.RATE.NOT_ENOUGH') }}
    </p>
    <p v-else class="mb-0 text-xs text-n-slate-11">
      {{ t('COMMERCIAL_WIDGETS_DIALOG.RATE.HINT') }}
    </p>
    <div class="flex flex-col">
      <span class="mb-1 text-sm font-medium text-n-slate-12">
        {{ t('COMMERCIAL_WIDGETS_DIALOG.RATE.NUMERATOR') }}
      </span>
      <ComboBox
        v-model="numeratorId"
        :options="operandOptions"
        :placeholder="t('COMMERCIAL_WIDGETS_DIALOG.RATE.PLACEHOLDER')"
        :has-error="isSameOperand"
      />
    </div>
    <div class="flex flex-col">
      <span class="mb-1 text-sm font-medium text-n-slate-12">
        {{ t('COMMERCIAL_WIDGETS_DIALOG.RATE.DENOMINATOR') }}
      </span>
      <ComboBox
        v-model="denominatorId"
        :options="operandOptions"
        :placeholder="t('COMMERCIAL_WIDGETS_DIALOG.RATE.PLACEHOLDER')"
        :has-error="isSameOperand"
        :message="
          isSameOperand ? t('COMMERCIAL_WIDGETS_DIALOG.RATE.MUST_DIFFER') : ''
        "
      />
    </div>
  </div>
</template>
